import dayjs from './dayjs';
import { DurationUnitType } from 'dayjs/plugin/duration';

export function DurationString(duration: number, unit: DurationUnitType = 'seconds'): string {
  const totalSeconds = dayjs.duration(duration, unit).asSeconds();

  const hoursString = (): string => {
    const hours = dayjs.duration(duration, unit).hours();
    return hours < 10 ? `0${hours}:` : `${hours}:`;
  };

  const minutesString = (): string => {
    const minutes = dayjs.duration(duration, unit).minutes();
    return minutes < 10 ? `0${minutes}` : `${minutes}`;
  };

  const secondsString = (): string => {
    const seconds = dayjs.duration(duration, unit).seconds();
    return seconds < 10 ? `:0${seconds}` : `:${seconds}`;
  };

  // Check if the total duration is less than one hour
  if (totalSeconds < 3600) {
    return `${minutesString()}${secondsString()}`;
  } else {
    return `${hoursString()}${minutesString()}${secondsString()}`;
  }
}
